/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProjectIndicatorJS_project$ref: FragmentReference;
declare export opaque type ProjectIndicatorJS_project$fragmentType: ProjectIndicatorJS_project$ref;
export type ProjectIndicatorJS_project = {|
  +name: ?string,
  +companyProjectId: ?number,
  +customProjectId: ?string,
  +projectColor: ?string,
  +$refType: ProjectIndicatorJS_project$ref,
|};
export type ProjectIndicatorJS_project$data = ProjectIndicatorJS_project;
export type ProjectIndicatorJS_project$key = {
  +$data?: ProjectIndicatorJS_project$data,
  +$fragmentRefs: ProjectIndicatorJS_project$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectIndicatorJS_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectColor",
      "storageKey": null
    }
  ],
  "type": "ProjectType"
};
// prettier-ignore
(node/*: any*/).hash = 'd0190be616dd55432ea6895a64642443';

module.exports = node;
